import { render, staticRenderFns } from "./TableData.vue?vue&type=template&id=3776d6fa&scoped=true"
import script from "./TableData.vue?vue&type=script&lang=ts"
export * from "./TableData.vue?vue&type=script&lang=ts"
import style0 from "./TableData.vue?vue&type=style&index=0&id=3776d6fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3776d6fa",
  null
  
)

export default component.exports